import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import GameSvcCdRelLstApi from "Apis/GameSvcCdRelLstApi";
import 'react-datepicker/dist/react-datepicker.css';
import MgpStore from "Stores/Store";

interface GameSvcSelectWithDatePickerProps {
    langData: any;
    selectedSvcCdState: string;
    selectedSvcNmState: string;
    onGameServiceChange: (gameSvcCd: string, gameNm: string) => void;
    onDateChange: (startDate: string, endDate: string, gameSvcCd?: string) => void;
    navigate: (path: string) => void;
}

const GameSvcSelectWithDatePicker: React.FC<GameSvcSelectWithDatePickerProps> = ({
    langData,
    selectedSvcCdState,
    selectedSvcNmState,
    onGameServiceChange,
    onDateChange,
    navigate
}) => {
    const [selectedPeriod, setSelectedPeriod] = useState(`1${langData?.MYPAGE_MONTH_LBL_01 || "개월"}`);

    // 기간 옵션 데이터
    const periodOptions = [
        { label: `1${langData?.MYPAGE_MONTH_LBL_01 || "개월"}`, months: 1 },
        { label: `3${langData?.MYPAGE_MONTH_LBL_00 || "개월"}`, months: 3 },
        { label: `6${langData?.MYPAGE_MONTH_LBL_00 || "개월"}`, months: 6 },
        { label: `12${langData?.MYPAGE_MONTH_LBL_00 || "개월"}`, months: 12 }
    ];

    useEffect(() => {
        if (!langData) {
            return;
        }

        const selectedMonths = parseInt(selectedPeriod, 10);
        const nextOption = periodOptions.find((option) => option.months === selectedMonths) || periodOptions[0];
        setSelectedPeriod(nextOption.label);
    }, [langData]);

    // 선택된 기간에 따라 날짜 범위를 계산하는 함수
    const calculateDateRange = (periodLabel: string) => {
        const endDate = new Date();
        const startDate = new Date();
        const selectedOption = periodOptions.find(option => option.label === periodLabel);
        if (selectedOption) {
            startDate.setMonth(endDate.getMonth() - selectedOption.months);
        }
        return { startDate, endDate };
    };

    // 초기 날짜를 선택된 기간에 맞춰 설정
    const initialDates = calculateDateRange(selectedPeriod);
    const [startDateState, setStartDateState] = useState(initialDates.startDate);
    const [endDateState, setEndDateState] = useState(initialDates.endDate);
    const [dpstAvlbState, setDpstAvlbState] = useState<any>([]);
    const [gameYrelLstSelectMenuStates, setGameYrelLstSelectMenuStates] = useState(false);
    const [periodSelectMenuStates, setPeriodSelectMenuStates] = useState(false);

    // 날짜를 YYYY-MM-DD 형태로 변환하는 함수
    const formatDateToString = (date: Date): string => {
        return date.toISOString().split('T')[0];
    };

    const GameYrelLstSelectMenuToggle = () => {
        setGameYrelLstSelectMenuStates(gameYrelLstSelectMenuStates => !gameYrelLstSelectMenuStates);
    };

    const PeriodSelectMenuToggle = () => {
        setPeriodSelectMenuStates(periodSelectMenuStates => !periodSelectMenuStates);
    };

    // 기간 선택 시 날짜 자동 설정
    const handlePeriodSelect = (period: string) => {
        const { startDate, endDate } = calculateDateRange(period);
        
        setStartDateState(startDate);
        setEndDateState(endDate);
        setSelectedPeriod(period);
        setPeriodSelectMenuStates(false);
        
        // 날짜 변경 콜백 호출
        onDateChange(formatDateToString(startDate), formatDateToString(endDate));
    };

    function returnOfIndex(value: string, dpstAvlbState: any) {
        let index;
        for (var i = 0; i < dpstAvlbState.length; i++) {
            if (dpstAvlbState[i].gameSvcNm.indexOf(value) != -1) {
                index = i;
            }
        }
        return index;
    }

    const SelectValueSetFunc = (value: string) => {
        var returnValue = returnOfIndex(value, dpstAvlbState);
        if (returnValue == undefined) {
            returnValue = 0;
        }
        let selectedGameSvcCd = dpstAvlbState[returnValue]?.gameSvcCd || "MGP";
        let selectedGameNm = dpstAvlbState[returnValue]?.gameSvcNm || (langData?.MYPAGE_SELT_VAL_ALL_DESC_00 || "전체");

        if (value === "MGP") {
            selectedGameSvcCd = "MGP";
            selectedGameNm = langData?.MYPAGE_SELT_VAL_ALL_DESC_00 || "전체";
        }

        setGameYrelLstSelectMenuStates(false); // 드롭다운 닫기
        
        // 게임 서비스 변경 시 새로 선택한 게임 서비스 코드와 현재 날짜로 API 호출
        onGameServiceChange(selectedGameSvcCd, selectedGameNm);
        onDateChange(formatDateToString(startDateState), formatDateToString(endDateState), selectedGameSvcCd);
    };

    const handleStartDateChange = (date: Date | null) => {
        if (date) {
            setStartDateState(date);
            onDateChange(formatDateToString(date), formatDateToString(endDateState));
        }
    };

    const handleEndDateChange = (date: Date | null) => {
        if (date) {
            setEndDateState(date);
            onDateChange(formatDateToString(startDateState), formatDateToString(date));
        }
    };

    useEffect(() => {
        if (!langData) {
            return;
        }

        GameSvcCdRelLstApi("MGP", "PC").then((resp) => {
            if (resp.apiHdr.code == "ATHN2014") {
                // 인증 오류 처리
            } else {
                if (resp.apiBody.gameSvcLst.length == 0) {
                    // alert(langData && langData.MYPAGE_GAME_REL_NO_DATA_00);
                    // return navigate("/MyPage/GameSvcRelLst");
                }
                setDpstAvlbState(resp.apiBody.gameSvcLst);
                // 초기 로딩시 게임 서비스 정보만 전달 (날짜는 부모 컴포넌트에서 초기화)
                onGameServiceChange("MGP", langData?.MYPAGE_SELT_VAL_ALL_DESC_00 || "전체");
            }
        });
    }, [MgpStore.getState().LangSetState.Lang, langData]);

    return (
        <div className="selectWrap">
            <div 
                className="ctxtLiTitl relative"
                onBlur={() => setGameYrelLstSelectMenuStates(false)}
                tabIndex={0}
            >
                <p 
                    className={gameYrelLstSelectMenuStates ? 'gameYrelSelectTitl active' : "gameYrelSelectTitl"} 
                    onClick={() => GameYrelLstSelectMenuToggle()}
                > 
                    {selectedSvcNmState || (langData?.MYPAGE_SELT_VAL_ALL_DESC_00 || "전체")}
                </p>
                <div className={gameYrelLstSelectMenuStates ? 'gameYrelWrap active' : "gameYrelWrap"}>
                    <ul>
                        <li onMouseDown={() => SelectValueSetFunc("MGP")}>
                            {langData && langData.MYPAGE_SELT_VAL_ALL_DESC_00}
                        </li>
                        {
                            dpstAvlbState && dpstAvlbState.map((key: any, index: number) => (
                                <li key={index} onMouseDown={() => SelectValueSetFunc(key.gameSvcNm)}>
                                    {key.gameSvcNm}
                                </li>
                            ))
                        }
                    </ul>
                </div>
            </div>
            <div className="datePickerWrap">
                <DatePicker 
                    selected={startDateState} 
                    onChange={handleStartDateChange}
                    selectsStart
                    startDate={startDateState}
                    endDate={endDateState}
                    dateFormat="yyyy-MM-dd"
                />
                <p>~</p>
                <DatePicker
                    selected={endDateState}
                    onChange={handleEndDateChange}
                    selectsEnd
                    startDate={startDateState}
                    endDate={endDateState} 
                    dateFormat="yyyy-MM-dd"
                />
            </div>
            <div 
                className="ctxtLiTitl relative periodSelect"
                onBlur={() => setPeriodSelectMenuStates(false)}
                tabIndex={0}
            >
                <p 
                    className={periodSelectMenuStates ? 'gameYrelSelectTitl active' : "gameYrelSelectTitl"} 
                    onClick={() => PeriodSelectMenuToggle()}
                > 
                    {selectedPeriod}
                </p>
                <div className={periodSelectMenuStates ? 'gameYrelWrap active' : "gameYrelWrap"}>
                    <ul>
                        {periodOptions.map((option, index) => (
                            <li key={index} onMouseDown={() => handlePeriodSelect(option.label)}>
                                {option.label}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default GameSvcSelectWithDatePicker;